import { Component, OnInit, OnChanges, ViewChild } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AuthService } from '@auth/auth.service';
import { DayMonth } from '../_const/const';
import { dateFormat } from '@core/_utils/date.utils';
import { PreferData, convertStringToBoolean, getPref, setUpdatePref } from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';

@Component({
    selector: 'dashboardstat',
    templateUrl: 'dashboardstat.component.html',
    styleUrls: ['dashboardstat.component.scss'],
})
export class DashBoardStatComponent implements OnInit, OnChanges {
    public fr: any;
    public error = false;
    public errorMessage = '';
    public isAdmin = false;
    public dataStat: any;
    public chartType: string;
    public statType: string;
    public nbDays: number;
    public totalDoc: number;
    public statNbDoc = false;
    public title: string;
    public rangeValues: number[] = [7,15];
    public statStyle: PreferData;
    public statPer: PreferData;
    private backgroundColor = [
        '#FF0000',
        '#E3005C',
        '#FF6400',
        '#C000B0',
        '#FF9200',
        '#7208BE',
        '#FFB400',
        '#3D0EC1',
        '#FFD300',
        '#102CC1',
        '#FFF500',
        '#0969B9',
        '#CDF800',
        '#8AEE00',
        '#00B894',
        '#00D50E',
    ];

    @ViewChild('overpanel') public overpanel;
    constructor(protected _messageService: MessagesService,
        private api: ApiV6Service,
        private auth: AuthService, private translate: TranslateService) {
        this.isAdmin = this.auth.isAdmin();
    }

    public ngOnInit() {
        this.title = this.translate.instant('Doc_Int');
        this.statType = 'year';
        this.nbDays = 7;
        this.chartType = 'doughnut';
        if (this.isAdmin === true) {
            this.execStat(this.nbDays);
        }
    }

    public ngOnChanges() {}

    private async execStat(aNbDays) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getuserpreference', ''));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Failed_GetUsrPref'));
            return;
        }

        this.statNbDoc = convertStringToBoolean(getPref(wRes.data, 6, 'false').datapref);
        this.statStyle = getPref(wRes.data, 7, 'doughnut');
        this.chartType = this.statStyle.datapref;
        this.statPer = getPref(wRes.data, 8, 'year');
        this.statType = this.statPer.datapref;

        const wParams = this.setRequest(this.statType, aNbDays);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getdatasetrequest', wParams));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.totalDoc = this.getTotDoc(wRes.data.ItemList);
        this.dataStat = this.setChart(wRes.data.ItemList, this.statType);
    }

    public onClickRb() {
        this.overpanel.hide();
        this.execUpdate();
    }

    private async execUpdate() {
        let wRes;
        let wRequestData: {};
        wRequestData = {
            requestData: setUpdatePref(this.statStyle.id, 7, this.chartType),
            initialize: false,
        };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('updatepreference', wRequestData));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        wRequestData = {
            requestData: setUpdatePref(this.statPer.id, 8, this.statType),
            initialize: false,
        };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('updatepreference', wRequestData));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        await this.execStat(this.nbDays);
    }

    private setChart(aDataStat, aStat) {
        if (aStat === 'year') {
            return this.setStatYear(aDataStat);
        }
        if (aStat === 'month') {
            return this.setStatMonth(aDataStat);
        }
        if (aStat === 'day') {
            return this.setStatDay(aDataStat);
        }
    }

    private getTotDoc(aData) {
        let wTotDoc = 0;
        aData.Item.forEach((item) => {
            wTotDoc += parseInt(item.NbDoc);
        });
        return wTotDoc;
    }

    private setLabel() {
        return this.translate.instant('Tot') + this.totalDoc;
    }

    private setRequest(aStat, aCount) {
        let wRequest = {
            RequestName: aStat,
            RequestCount: aCount,
        };
        return wRequest;
    }

    private setStatYear(aDataStat) {
        let wVal;
        let wLabels = [];
        let wData = [];
        aDataStat.Item.reverse().map((item) => {
            wLabels.push(item.Date);
            wData.push(item.NbDoc);
        });
        wVal = {
            labels: wLabels,
            datasets: [
                {
                    label: this.setLabel(),
                    backgroundColor: this.backgroundColor,
                    fill: false,
                    data: wData,
                    tension: .5
                },
            ],
        };
        return wVal;
    }

    private setStatMonth(aDataStat) {
        let wVal;
        let wLabels = [];
        let wData = [];
        let wMonth = [];
        wMonth = this.translate.instant('primeng.monthNames');
        aDataStat.Item.map((item) => {
            wLabels.push(wMonth[parseInt(item.Date) - 1]);
            wData.push(item.NbDoc);
        });
        wVal = {
            labels: wLabels,
            datasets: [
                {
                    label: this.setLabel(),
                    backgroundColor: this.backgroundColor,
                    fill: false,
                    data: wData,
                    tension: .5
                },
            ],
        };
        return wVal;
    }

    private setStatDay(aDataStat) {
        let wVal;
        let wLabels = [];
        let wData = [];
        aDataStat.Item.map((item) => {
            // wLabels.push(item.Date);
            wLabels.push(dateFormat(item.Date, 'EEEE MMMM d', this.translate.instant('lang')));
            wData.push(item.NbDoc);
        });
        wVal = {
            labels: wLabels,
            datasets: [
                {
                    label: this.setLabel(),
                    backgroundColor: this.backgroundColor,
                    fill: false,
                    data: wData,
                    tension: .5
                },
            ],
        };
        return wVal;
    }
}
